function Failure(axios, baseUrl) {

    this.axios = axios;
    this.baseUrl = `${baseUrl}failure`;


    this.get = function(id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    this.failureList = function(selectedPage, onlyUnsolvedFailures) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/failureList/${selectedPage}/${onlyUnsolvedFailures}`);
    }
    this.add = function(model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function(model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
    this.remove = function(id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}/${id}`);
    }
}

export default Failure